const FIRESTORE_CONSTS = {
	FORMS: 'forms',
	RESPONSES: 'responses',
	USERS: 'users',
	USER_ID: 'userId',
	FORM_ID: 'formId'
};
export default FIRESTORE_CONSTS;
